import {useSearchParams} from "react-router-dom";

const useCustomPaging = () => {
  const [searchParams, setSearchParams] = useSearchParams()
  const currentPageFilter = searchParams.get('pageNumber') ?? '0'

  const changeFilterWithoutPage = (key, value) => {
    const newSearchParams = new URLSearchParams(searchParams ?? {});
    newSearchParams.set(key, value);
    newSearchParams.set('pageNumber', '0')
    setSearchParams(newSearchParams);
  }
  const changeFilters = (key, value) => {
    const newSearchParams = new URLSearchParams(searchParams ?? {});
    newSearchParams.set(key, value);
    setSearchParams(newSearchParams);
  }
  const handlePageNumberChange = (newPageNumber) => {
    const newPage = newPageNumber > 0 ? newPageNumber : 0
    changeFilters('pageNumber', newPage)
  }
  const changeMultipleDateFilterWithoutPage = (dates) => {
    const newSearchParams = new URLSearchParams(searchParams ?? {});
    newSearchParams.set('startDate', dates.startDate);
    newSearchParams.set('endDate', dates.endDate)
    newSearchParams.set('pageNumber', '0')
    setSearchParams(newSearchParams);
  }

  return [
    currentPageFilter,
    changeFilterWithoutPage,
    handlePageNumberChange,
    changeFilters,
    changeMultipleDateFilterWithoutPage
  ] as const
}

export default useCustomPaging
